import { makeStyles } from "@material-ui/core";

const widthMargin = 10;

export const RdxInputStyles = makeStyles((theme) => ({
  flexBox: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  optionsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  boldIcon: {
    "& .MuiButtonBase-root span svg": {
      fill: "black",
    },
  },
  inputContainer: {
    width: (props) => {
      if (props["takeMargin"]) {
        return `calc(${props["rate"] || 100}% + ${widthMargin}px) !important`;
      } else {
        if (typeof props["rate"] === "number") {
          return `${props["rate"] || 100}% !important`;
        } else {
          return `${props["rate"] || `100%`} !important`;
        }
      }
    },
    marginTop: 8,
    marginBottom: 8,
    textAlign: "start",
    marginLeft: (props) =>
      props["takeMargin"] ? `${widthMargin}px !important` : "0px !important",
    marginRight: 0,
    [theme.breakpoints.down("md")]: {
      marginTop: 5,
      marginBottom: 5,
    },
    "& label.Mui-focused": {
      color: "white",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#99D7CF",
    },
    "& .MuiOutlinedInput-root": {
      padding: "11px 10px",
      fontSize: 18,
      [theme.breakpoints.down("sm")]: {
        marginTop: 4,
        padding: "6px 8px",
        fontSize: 16,
      },
      "& fieldset": {
        // borderColor: "#99D7CF",
        borderColor: "transparent",
        borderWidth: 2,
        borderRadius: 360,
      },
      "&:hover fieldset": {
        borderColor: "#008472",
        borderWidth: 3,
      },
      "&.Mui-focused fieldset": {
        borderColor: "#008472",
        borderWidth: 3,
      },
      "& .Mui-error": {
        display: "none !important",
      },
    },
    "& .MuiAutocomplete-endAdornment": {
      right: "20px !important",
      [theme.breakpoints.down("sm")]: {
        right: "16px !important",
        top: 6,
      },
    },
    "& .MuiAutocomplete-clearIndicator": {
      marginRight: 10,
    },
  },
  addressContainer: {
    margin: "0px !important",
    "& .MuiOutlinedInput-root": {
      [theme.breakpoints.down("md")]: {
        marginTop: 0,
      },
    },
  },
  endAdornment: {
    display: "flex",
    alignItems: "center",
    paddingRight: 10,
    [theme.breakpoints.down("md")]: {
      paddingRight: 13,
    },
  },
  autoCompContainer: {
    marginBottom: (props) => (props["label"] ? 10 : 0),
    marginTop: (props) => (props["label"] ? 10 : 15),
    paddingTop: (props) => (!props["label"] && props["error"] ? 0 : "auto"),
    [theme.breakpoints.down("md")]: {
      marginTop: (props) => (props["label"] ? 5 : 0),
      marginBottom: (props) => (props["label"] ? 5 : 0),
      paddingTop: "0px !important",
      paddingBottom: (props) => (props["error"] ? 12 : 0),
    },
  },
  checkboxContainer: {
    marginLeft: 11,
    [theme.breakpoints.down("md")]: {
      marginLeft: 6,
    },
  },
  "@global": {
    ".Mui-error": {
      marginTop: 0,
      lineHeight: 1.2,
    },
    "::placeholder": {
      fontFamily: "Futura PT Book",
      color: "#828282 !important",
      fontSize: 18,
      [theme.breakpoints.down("md")]: {
        fontSize: 16,
      },
    },
  },
  textField: {
    minHeight: "40px",
    width: "100%",
    // marginBottom: 18,
    border: 0,
    fontSize: 18,
    borderRadius: 360,
    [theme.breakpoints.down("md")]: {
      width: "100%",
      // marginBottom: (props) => props["error"] ? 22 : 12
    },
  },
  addressTextField: {
    marginBottom: 0,
    [theme.breakpoints.down("md")]: {
      marginBottom: "0px !important",
    },
  },
  inputBox: {
    position: "relative",
    marginTop: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: 0,
    marginRight: 180,
    [theme.breakpoints.down("md")]: {
      marginRight: 0,
      marginTop: 20,
      paddingLeft: 10,
      paddingRight: 10,
      flexDirection: "column",
      alignItems: "center",
    },
  },
  customTextField: {
    "& input::placeholder": {
      color: "red !important",
    },
  },
  errorContainer: {
    position: "absolute",
    bottom: -18,
    [theme.breakpoints.down("md")]: {
      // position: "static",
      bottom: 0,
    },
  },
  phoneLabelCss: {
    color: "#adacac",
    fontSize: 12,
  },
  phoneButton: {
    width: 30,
    height: 30,
    marginTop: 10,
    borderRadius: "10px !important",
  },
  phoneLabelCssOnFocus: {
    color: "#008A45",
    fontSize: 12,
  },
  textfieldLabel: {
    marginTop: 2,
    marginBottom: 1,
    fontSize: "14px",
  },
  inputProps: {
    fontSize: "16px",
    fontFamily: "Roboto",
    lineHeight: "17px",
    backgroundColor: "#ededed",
    border: "0px !important",
    padding: "0px 14px",
  },
  addressInputProps: {
    padding: "10px 14px",
  },
  errortext: {
    // textTransform: "uppercase",
    fontFamily: "Roboto",
    fontSize: "0.75rem !important",
    color: "#f44336",
    lineHeight: 1.66,
    fontWeight: 400,
    marginLeft: 14,
  },
  optionText: {
    fontSize: 16,
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
  checkBox: {
    width: 20,
    height: 20,
    objectFit: "contain",
    border: "1px solid #DDE2E7",
  },
  themedButtonContained: {
    color: "white",
    background:
      "transparent linear-gradient(270deg, #D62020 0%, #FF7676 100%) 0% 0% no-repeat padding-box",
    height: "56px",
    marginTop: 0,
    width: "100%",
    fontSize: "18px",
    letterSpacing: "0.11px",
    padding: "6px 1vw",
    [theme.breakpoints.down("md")]: {
      marginTop: 10,
      marginLeft: 0,
    },
  },
  themedButtonOutlined: {
    color: "#D62020",
    height: "56px",
    marginTop: 0,
    width: "100%",
    fontSize: "18px",
    letterSpacing: "0.11px",
    padding: "6px 1vw",
    border: "1px solid #D62020",
    [theme.breakpoints.down("md")]: {
      marginTop: 10,
      marginLeft: 0,
    },
  },
  themedButtonDisabled: {
    color: "white !important",
    background:
      "transparent linear-gradient(270deg, #849b9b 0%, #c0c0c0 100%) 0% 0% no-repeat padding-box;",
    height: "56px",
    marginTop: 0,
    width: "100%",
    fontSize: "18px",
    letterSpacing: "0.11px",
    padding: "6px 1vw",
    [theme.breakpoints.down("md")]: {
      marginTop: 10,
      marginLeft: 0,
    },
  },
  optionMainBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "56px",
    border: "1px solid #FF7676",
    boxShadow: "0px 3px 6px #FF767629",
    borderRadius: "10px",
    paddingLeft: "12px",
    width: "100%",
  },
  selectOptionMainBox: {
    display: "flex",
    height: "140px",
    border: "1px solid #FF7676",
    boxShadow: "0px 3px 6px #FF767629",
    borderRadius: "10px",
    paddingLeft: "12px",
    width: "200px",
    flexDirection: "column",
    justifyContent: "center",
  },
  imageForOption: {
    display: "flex",
    justifyContent: "center",
  },
  dropzone: {
    opacity: 0,
    position: "absolute",
    height: 100,
    width: 900,
    cursor: "pointer",
    // zIndex: -1
  },
  // errorAuto: {
  //     padding: "2px !important",
  // },
  autoInput: {
    maxWidth: "50ch",
    whiteSpace: "nowrap",
    overflow: "hidden !important",
    textOverflow: "ellipsis !important",
    [theme.breakpoints.down("md")]: {
      padding: "11px 6px !important",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "30ch",
      padding: "6px 6px !important",
    },
  },
  submitButton: {
    width: "20rem",
    padding: "16px 24px 16px 24px !important",
    textTransform: "uppercase",
    color: "#fff",
    fontWeight: "bold !important",
    fontSize: "18px !important",
    borderRadius: "360px !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px !important",
      padding: "6px 24px 6px 24px !important",
    },
  },
  cancelButton: {
    width: "20rem",
    padding: "14px 24px 14px 24px !important",
    textTransform: "uppercase",
    fontWeight: "bold !important",
    fontSize: "18px !important",
    borderRadius: "360px !important",
    borderWidth: "2px !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px !important",
      padding: "6px 24px 6px 24px !important",
    },
  },
}));
